import CarouselAssetComponent from "./carousel-asset-component";
import CarouselAssetConfig from "./carousel-asset-config";
import CarouselAssetAdvancedConfig from "./carousel-asset-advanced-config";

export default {
  CarouselAssetComponent,
  CarouselAssetConfig,
  CarouselAssetAdvancedConfig
};
